<template>
  <div>
    <v-card class="main pa-2">
      <v-toolbar dense flat>
        <v-toolbar-title class="body-2 beez-bold">
          Task Sync Report
        </v-toolbar-title>
        <v-spacer />
        <v-tooltip bottom>
          <v-btn slot="activator" :loading="loader" flat icon @click="refresh">
            <v-icon>
              refresh
            </v-icon>
          </v-btn>
          <span>Refresh</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-layout>
          <v-flex xs12>
            <v-layout row wrap justify-space-around align-center>
              <v-flex xs12 md4>
                <v-btn
                  color="primary"
                  @click="replicateAllTasksFromEngine"
                  class="text-capitalize"
                >
                  Replicate All tasks to Beekeeper
                </v-btn>
              </v-flex>
              <v-flex xs12 md4>
                <v-btn
                  color="primary"
                  @click="syncAllTaskBeekeeper"
                  class="text-capitalize"
                >
                  Sync all Beekeeper tasks
                </v-btn>
              </v-flex>
              <v-flex xs12 md4>
                <v-btn
                  color="primary"
                  @click="updateAllTasksDimensions"
                  class="text-capitalize"
                >
                  Update all task Dimensions
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-text-field
          v-model="search"
          color="secondary"
          label="Search"
          @change="refresh"
        >
        </v-text-field>
        <v-data-table
          :headers="headers"
          :items="taskCountReport"
          :loading="loader"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :rows-per-page-items="headerPageItems"
          item-key="Assignee"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">{{ props.item.Assignee }}</td>
              <td class="text-xs-left">
                {{ props.item.TasksInWorkflowEngine }}
              </td>
              <td class="text-xs-left">{{ props.item.TasksInBeekeeper }}</td>
              <td class="text-xs-left">
                <v-btn
                  flat
                  outline
                  :loading="replicateLoader"
                  @click="replicateTaskFromEngine(props.item.Assignee)"
                  class="text-capitalize"
                  >Replicate
                </v-btn>
              </td>
              <td class="text-xs-left">
                <v-btn
                  flat
                  outline
                  :loading="syncLoader"
                  @click="syncTaskInBeekeeper(props.item.Assignee)"
                  class="text-capitalize"
                  >Sync
                </v-btn>
              </td>
              <td class="text-xs-left">
                <v-btn
                  flat
                  outline
                  :loading="dimUpdateLoader"
                  @click="updateTaskDimensions(props.item.Assignee)"
                  class="text-capitalize"
                  >Update
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'TaskSyncAdmin',
  data() {
    return {
      rowsPerPage: 0,
      descending: false,
      currentPage: 0,
      sortBy: '',
      loader: false,
      replicateLoader: false,
      dimUpdateLoader: false,
      syncLoader: false,
      search: '',
      headerPageItems: [5, 10, 25],
      pagination: {
        sortBy: 'Assignee',
        rowsPerPage: 10,
        descending: false,
        totalItems: 0,
        page: 1
      },
      headers: [
        {
          text: 'User ID',
          align: 'left',
          value: 'Assignee'
        },
        {
          text: 'Tasks in Workflow Engine',
          value: 'TasksInWorkflowEngine',
          sortable: false
        },
        {
          text: 'Tasks in Beekeeper',
          value: 'TasksInBeekeeper',
          sortable: false
        },
        {
          text: 'Replicate tasks to Beekeeper',
          sortable: false
        },
        {
          text: 'Sync tasks in Beekeeper',
          sortable: false
        },
        {
          text: 'Update Task Dimension',
          sortable: false
        }
      ]
    }
  },
  computed: {
    ...mapState({
      taskCountReport: state => state.admin.taskCountReport,
      camundaUserCount: state => state.admin.camundaUserCount
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  mounted() {
    this.pagination.totalItems = this.camundaUserCount
    this.getTaskCountReport()
  },
  watch: {
    camundaUserCount() {
      this.pagination.totalItems = this.camundaUserCount
    },
    pagination: {
      handler() {
        try {
          if (
            this.pagination.page !== this.currentPage ||
            this.pagination.rowsPerPage !== this.rowsPerPage ||
            this.pagination.sortBy !== this.sortBy ||
            this.pagination.descending !== this.descending
          ) {
            this.currentPage = this.pagination.page
            this.rowsPerPage = this.pagination.rowsPerPage
            this.sortBy = this.pagination.sortBy
            this.descending = this.pagination.descending
            this.refresh()
          }
          // eslint-disable-next-line no-empty
        } catch (error) {}
      },
      deep: true
    }
  },
  methods: {
    refresh() {
      this.getTaskCountReport()
    },
    async updateTaskDimensions(assignee) {
      try {
        let res = await this.$confirm(
          `This is a bulk operation. Are you sure you want to continue?`,
          {
            title: 'Warning'
          }
        )
        if (res) {
          this.dimUpdateLoader = true
          await this.$store.dispatch('updateTaskDimensions', assignee)
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Error while raising request',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.dimUpdateLoader = false
    },
    async updateAllTasksDimensions() {
      try {
        let res = await this.$confirm(
          `This is a bulk operation. Are you sure you want to continue?`,
          {
            title: 'Warning'
          }
        )
        if (res) {
          this.dimUpdateLoader = true
          await this.$store.dispatch('updateAllTasksDimensions')
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Error while raising request',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.dimUpdateLoader = false
    },
    async syncTaskInBeekeeper(assignee) {
      try {
        let res = await this.$confirm(
          `This is a bulk operation. Are you sure you want to continue?`,
          {
            title: 'Warning'
          }
        )
        if (res) {
          this.syncLoader = true
          await this.$store.dispatch('syncTaskInBeekeeper', assignee)
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Error while raising request',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.syncLoader = false
    },
    async syncAllTaskBeekeeper() {
      try {
        let res = await this.$confirm(
          `This is a bulk operation. Are you sure you want to continue?`,
          {
            title: 'Warning'
          }
        )
        if (res) {
          this.syncLoader = true
          await this.$store.dispatch('syncAllTaskInBeekeeper')
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Error while raising request',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.syncLoader = false
    },
    async replicateTaskFromEngine(assignee) {
      try {
        let res = await this.$confirm(
          `This is a bulk operation. Are you sure you want to continue?`,
          {
            title: 'Warning'
          }
        )
        if (res) {
          this.replicateLoader = true
          await this.$store.dispatch('replicateTaskFromEngine', assignee)
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Error while raising request',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.replicateLoader = false
    },
    async replicateAllTasksFromEngine() {
      try {
        let res = await this.$confirm(
          `This is a bulk operation. Are you sure you want to continue?`,
          {
            title: 'Warning'
          }
        )
        if (res) {
          this.replicateLoader = true
          await this.$store.dispatch('replicateAllTasksFromEngine')
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Error while raising request',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.replicateLoader = false
    },
    async getTaskCountReport() {
      this.loader = true
      let params = {}
      params.firstResult =
        this.pagination.page * this.pagination.rowsPerPage -
        this.pagination.rowsPerPage
      params.maxResults = this.pagination.rowsPerPage
      params.sortOrder = this.pagination.descending ? 'desc' : 'asc'
      if (this.search) {
        params.firstNameLike = this.search
      }
      try {
        await this.$store.dispatch('fetchTaskCountReport', params)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Error while fetching the task counts by user',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.loader = false
    }
  }
}
</script>

<style scoped></style>
